export const color_next_machine_not_available = '#fb6340'
export const color_alarm = '#f5365c'
export const color_running = '#a0c638'
export const color_stopped = '#11cdef'